import { render, staticRenderFns } from "./MainUserIcon.vue?vue&type=template&id=c8bcdd68&scoped=true&"
import script from "./MainUserIcon.vue?vue&type=script&lang=js&"
export * from "./MainUserIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c8bcdd68",
  null
  ,true
)

export default component.exports